import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-37031ef5"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "table__container"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = {
  class: "table-list",
  ref: "tableWarpRef"
};
import { useI18n } from 'vue-i18n';
import dayjs from 'dayjs';
import { onMounted } from 'vue';
import { getLogListApi } from '@/api/traceDebug';
import { getSysDictListApi } from '@/api/live';
import { ElMessage } from 'element-plus';
import { getCurrentTime } from '@/utils/timeFormat';
import Buttons from '@/components/Buttons/index.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const loading = ref(false);
    const functionObj = ref([{
      label: t('全部'),
      value: 'All'
    }]);
    const tableRef = ref();
    onMounted(() => {
      getModuleObj('module_type');
      getModuleObj('function_type');
    });
    const tableConfig = reactive({
      data: [],
      isCardBlock: true,
      paginationConfig: {
        page: 1,
        limit: 10,
        total: 0
      },
      isShowHeader: false,
      headerButtonsList: [{
        label: '',
        key: 0,
        func: () => {},
        cellSlot: true
      }]
    });
    const timeOption = ref([{
      value: 0,
      label: t('最近30分钟')
    }, {
      value: 1,
      label: t('最近一小时')
    }, {
      value: 2,
      label: t('今天')
    }, {
      value: 3,
      label: t('昨天')
    }]);
    const loginOPtion = [{
      value: 0,
      label: 'SN'
    }, {
      value: 1,
      label: t('账号')
    }, {
      value: 2,
      label: t('激活码')
    }];
    const modelObj = ref([{
      value: 'all',
      label: t('全部')
    }]);
    const timeObj = ref({
      0: {
        start: dayjs().startOf('minute').subtract(30, 'minute').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('minute').format('YYYY-MM-DD HH:mm:ss')
      },
      1: {
        start: dayjs().startOf('minute').subtract(60, 'minute').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('minute').format('YYYY-MM-DD HH:mm:ss')
      },
      2: {
        start: dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      },
      3: {
        start: dayjs().startOf('day').subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('day').subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')
      }
    });
    const logNameDisabled = ref(false);
    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '开始时间',
        prop: 'startTime',
        widgetType: 'dateTime'
      }, {
        label: '结束时间',
        prop: 'endTime',
        widgetType: 'dateTime'
      }, {
        label: '',
        prop: 'timeType',
        widgetType: 'Select',
        list: timeOption,
        change: val => {
          // 变更时间
          searchConfig.formData.startTime = timeObj.value[val].start;
          searchConfig.formData.endTime = timeObj.value[val].end;
        }
      }, // { label: '模块', prop: 'logName', widgetType: 'Select' , list: modelObj, valueKey: 'label', disabled: false },
      {
        label: '功能',
        prop: 'functionType',
        widgetType: 'Select',
        list: functionObj,
        change: val => {
          console.log('val', val, t('全部')); //选中全部，模块取消禁用
          //if(val==='All') return searchConfig.formList[3].disabled = false
          //选中其他选项，模块显示全部并禁用

          searchConfig.formData.logName = t('全部'); //searchConfig.formList[3].disabled = true
        }
      }, {
        label: '账号',
        prop: 'keyWord',
        widgetType: 'input'
      }],
      formData: {
        startTime: dayjs().startOf('minute').subtract(30, 'minute').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf('minute').format('YYYY-MM-DD HH:mm:ss'),
        timeType: 0,
        keyWord: '',
        logName: t('全部'),
        functionType: 'All'
      }
    });

    const handleSearch = val => {
      console.log('searc', val);
      if (!val.logName || val.logName.trim() === '') return ElMessage({
        type: 'warning',
        message: t('请选择模块')
      });
      if (!val.keyWord || val.keyWord.trim() === '') return ElMessage({
        type: 'warning',
        message: t('请输入账号')
      });
      const {
        keyWord,
        logName,
        startTime,
        endTime
      } = val;
      let params = {
        keyWord,
        logName: val.logName === t('全部') ? undefined : val.logName,
        startTime,
        endTime,
        page: 1,
        size: 10,
        requestUrl: val.functionType === 'All' ? undefined : val.functionType
      };
      getLogList(params);
    }; //重置


    const handleReset = () => {
      tableConfig.data = [];
      tableConfig.paginationConfig = {
        page: 1,
        total: 0,
        limit: 10
      };
      searchConfig.formData = {
        startTime: dayjs().startOf('minute').subtract(30, 'minute').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf('minute').format('YYYY-MM-DD HH:mm:ss'),
        timeType: 0,
        keyWord: '',
        logName: t('全部'),
        functionType: 'All'
      };
      searchConfig.formList[3].disabled = false;
    }; // 获取日志列表


    const getLogList = async params => {
      loading.value = true;
      const {
        data,
        code
      } = await getLogListApi(params);

      if (code == 0) {
        tableConfig.paginationConfig.page = data.current;
        tableConfig.paginationConfig.total = data.total;
        tableConfig.paginationConfig.limit = data.size;
        tableConfig.data = data.records;

        if (data.records.length === 0) {
          loading.value = false;
          return ElMessage({
            type: 'warning',
            message: t('未查询到数据')
          });
        }
      }

      loading.value = false;
    };

    const columnConfig = reactive({
      columnList: [{
        label: '时间',
        prop: 'time',
        align: 'left',
        width: 200,
        formatter: value => getCurrentTime(value)
      }, {
        label: '用户名',
        prop: 'userName',
        align: 'left',
        width: 150,
        cellSlot: true,
        slotName: 'userNameColumn'
      }, {
        label: 'IP',
        prop: 'clientIp',
        align: 'left',
        width: 110
      }, {
        label: '模块',
        prop: 'logName',
        align: 'left',
        width: 110
      }, {
        label: '请求链接',
        prop: 'requestUrl',
        align: 'left',
        width: 300
      }, // { label: '请求参数', prop: 'requestParam', align:'left', width:300 },
      {
        label: '返回状态',
        prop: 'responseStatus',
        align: 'left',
        width: 120
      }, {
        label: '返回数据',
        prop: 'responseBody',
        align: 'left',
        minWidth: 120
      }, {
        label: 'ClientIp',
        prop: 'clientIp',
        align: 'left'
      }, {
        label: 'UiLang',
        prop: 'uiLang',
        align: 'left'
      }, {
        label: 'UserToken',
        prop: 'usertoken',
        align: 'left',
        minWidth: 120
      }, {
        label: '终端类型',
        prop: 'terminalType',
        align: 'left',
        minWidth: 120
      }, {
        label: '账号类型',
        prop: 'accountType',
        align: 'left',
        minWidth: 120
      }, {
        label: 'Method',
        prop: 'method',
        align: 'left',
        minWidth: 120
      }, {
        label: 'ForwardeFor',
        prop: 'forwardeFor',
        align: 'left',
        minWidth: 120
      }, {
        label: 'RequestSize',
        prop: 'requestSize',
        align: 'left',
        minWidth: 120
      }, {
        label: 'ContentType',
        prop: 'contentType',
        align: 'left',
        minWidth: 120
      }]
    }); // 分页size变化的回调

    const sizeChange = size => {
      tableConfig.paginationConfig.limit = size;
      const {
        keyWord,
        logName,
        startTime,
        endTime
      } = searchConfig.formData;
      let params = {
        keyWord,
        logName: searchConfig.formData.logName === t('全部') ? undefined : searchConfig.formData.logName,
        startTime,
        endTime,
        page: 1,
        size,
        requestUrl: searchConfig.formData.functionType === 'All' ? undefined : searchConfig.formData.functionType
      };
      getLogList(params);
    }; // 页码变化的回调


    const currentChange = page => {
      tableConfig.paginationConfig.page = page;
      const {
        keyWord,
        logName,
        startTime,
        endTime
      } = searchConfig.formData;
      let params = {
        keyWord,
        logName: searchConfig.formData.logName === t('全部') ? undefined : searchConfig.formData.logName,
        startTime,
        endTime,
        page: page,
        size: tableConfig.paginationConfig.limit,
        requestUrl: searchConfig.formData.functionType === 'All' ? undefined : searchConfig.formData.functionType
      };
      getLogList(params);
    };

    const getModuleObj = async type => {
      const {
        code,
        data
      } = await getSysDictListApi(type);

      if (code == 0) {
        if (type === 'module_type') {
          modelObj.value = [...modelObj.value, ...data];
        } else {
          let remoteData = data.map(item => {
            return { ...item,
              label: t(item.label)
            };
          });
          functionObj.value = functionObj.value.concat(remoteData);
        }
      }
    };

    const filterColumnItemChange = () => {
      nextTick(() => {
        tableRef.value && tableRef.value.commonTableRef.doLayout();
      });
    };

    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _directive_crosswiseScroll = _resolveDirective("crosswiseScroll");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_search_form, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        size: searchConfig.size,
        onSearch: handleSearch,
        onReset: handleReset,
        gutter: 50
      }, null, 8, ["form-list", "form-data", "size"])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(Buttons, {
        class: "header__btns",
        "buttons-list": tableConfig.headerButtonsList
      }, {
        cellSlot: _withCtx(scope => [scope.key == 0 ? (_openBlock(), _createBlock(_component_TableColumnOptionBtn, {
          key: 0,
          "column-list": columnConfig.columnList,
          onFilterColumnItemChange: filterColumnItemChange
        }, null, 8, ["column-list"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["buttons-list"])])), [[_directive_crosswiseScroll]]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_common_table, {
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        ref_key: "tableRef",
        ref: tableRef,
        onSizeChange: sizeChange,
        onCurrentChange: currentChange,
        onSelectionChange: _ctx.handleSelectionChange,
        onSortChange: _ctx.handleSortChange
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          userNameColumn: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.userName ? scope.row.userName : scope.row.userid ? scope.row.userid : '--'), 1)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config", "onSelectionChange", "onSortChange"])], 512)])), [[_directive_loading, loading.value]])], 64);
    };
  }

});